import { render } from "./FaqPortal.vue?vue&type=template&id=859560d2"
import script from "./FaqPortal.vue?vue&type=script&lang=js"
export * from "./FaqPortal.vue?vue&type=script&lang=js"

import "./FaqPortal.vue?vue&type=style&index=0&id=859560d2&lang=css"

import exportComponent from "/builds/octoblue/narrowcastingrpi/narrowcastingwebapp/narrowcasting_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__